import { useQuery } from "@tanstack/react-query";
import { axiosGet } from "@/services/axiosService";
import { getAccounts } from "@/services/googlepicker.service";

export default function useGooglePickerConfig() {
  return useQuery({
    queryKey: ["googlePickerConfigs"],
    queryFn: async () => {
      const response = await getAccounts();
      return response.length > 0 ? response : null;
    },
    staleTime: Infinity,
  });
}
